<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/Stores/Auth';

// Layout components
import UserMain       from '@/Views/Includes/UserMain.vue';        // Public navbar (guest)
import HeaderComponent from '@/Views/Includes/HeaderComponent.vue'; // Auth header
import MenuSection    from '@/Views/Includes/MenuSection.vue';      // Auth sidebar

const authStore = useAuthStore();
const route = useRoute();

onMounted(async () => {
  await authStore.initializeAuth();
});

const isAuthenticated = computed(() => authStore.isAuthenticated);
const isAdminPage = computed(() => {
  const path = route.path.toLowerCase();
  return path.startsWith('/admin');
});
</script>

<template>
  <div class="app-container">
    <!-- ── ADMIN: show clean layout without global navs ─────────── -->
    <template v-if="isAdminPage">
      <main class="admin-content">
        <router-view />
      </main>
    </template>

    <!-- ── GUEST: show public top nav ────────────────────────────── -->
    <template v-else-if="!isAuthenticated">
      <UserMain />
      <main class="guest-content">
        <router-view />
      </main>
    </template>

    <!-- ── AUTH: show dashboard header + sidebar ─────────────────── -->
    <template v-else>
      <HeaderComponent />
      <MenuSection />
      <main class="auth-content">
        <router-view />
      </main>
    </template>

    <!-- Footer intentionally removed -->
  </div>
</template>

<style>
/* Global styles for app layout */
.app-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* When authenticated, the header and sidebar are fixed */
.auth-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: rgba(255, 255, 255, 0.692);
}

@media (min-width: 768px) {
  .auth-content {
    margin-left: 12rem; /* Sidebar width (w-48) */
  }
}

/* For non-auth content, just a simple flex column */
.guest-content {
  flex: 1;
  overflow-y: auto;
  margin-top: 80px; /* Height of fixed UserMain header (h-20) */
  background-color: rgba(255, 255, 255, 0.692);
}

.admin-content {
  flex: 1;
  overflow-y: auto;
  background-color: #f8fafc; /* Slightly different bg for admin */
}
</style>